import { constants } from 'buffer';
import React, { useEffect, useRef, useState } from 'react';
import Tools from '../../../cvp-webgames-core/Misc/Tools';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
var interval: any = null;
const SingleGraphUI = (props: UIProperties<SingleGraphUIMainConfig>) => {
	// const [isVisible, setIsVisible] = useState(true);
	const etc02Id = 'etc02-graph';
	const canvas = useRef(null);
	var isVisible = true;
	const createChart = () => {
		if (!canvas) {
			return;
		}
		var graphInstance = new Graph(canvas.current, props.parameters.initData.lineColor, props.parameters.initData.showGrid, props.parameters.initData.centerHeight);
		graphInstance.init();

		var index = 0;
		var initialValue = 40.32;
		var fillerStartValue = 20;
		var currentGraph: SingleGraphUIConfig = null;
		var coordinates = props.parameters.initData.defaultCoordinates;

		const refreshGraph = () => {
			currentGraph = props.parameters.onGetGraph();
			coordinates = !currentGraph || typeof currentGraph.coordinates === 'undefined' ?
							props.parameters.initData.defaultCoordinates :
							currentGraph.coordinates;

			setTimeout(refreshGraph, 250);
		}

		refreshGraph();

		const drawNextCoordinates = () => {
			if (index >= coordinates.length) {
				if(!props.parameters.initData.smoothlyZeroOut){
					graphInstance.drawValue(0)
				}
				else {
					var step = currentGraph.smoothStep;
					var newValue = initialValue-step;
					initialValue = newValue;
					var currentValue = newValue;
					fillerStartValue = currentValue;

					graphInstance.drawValue(currentValue);
				}

				setTimeout(() => {
					index = 0;
					initialValue = 40.32;
				},  typeof currentGraph.curveResetTimer === 'undefined' ?
						props.parameters.initData.defaultCurveResetTimer :
						currentGraph.curveResetTimer);
			}
			else {
				if (index <= 13 && props.parameters.initData.smoothlyZeroOut) {
					var newStep = currentGraph.smoothStep;
					var fillerValue = fillerStartValue-newStep;
					fillerStartValue = fillerValue;
					var newCurrentValue = fillerValue;

					graphInstance.drawValue(newCurrentValue);
				}
				else {
					graphInstance.drawValue(coordinates[index]);
				}
			}

			index++;

			// if (index > coordinates.length) {
			// 	setTimeout(() => {
			// 		index = 0;
			// 		initialValue = 40.32
			// 	},  typeof currentGraph.curveResetTimer === 'undefined' ?
			// 			props.parameters.initData.defaultCurveResetTimer :
			// 			currentGraph.curveResetTimer);
			// }
		}

		setInterval(drawNextCoordinates, props.parameters.initData.timeInterval);
	}

	useEffect(() => {
		setTimeout(() => {
			createChart();
		}, 2000);
		if(props.parameters.onUpdateVisibility) {
			if(interval) {
				clearInterval(interval);
				interval = null;
			}
			interval = setInterval(() => {
				var newVisibility = props.parameters.onUpdateVisibility();
				if(isVisible !== newVisibility) {
					isVisible = newVisibility;
					document.getElementById(etc02Id).style.opacity = isVisible ? '1' : '0'; 
				}
			}, 3000);
		}
		
	}, [])
	return (
		<div id={props.parameters.onUpdateVisibility ? etc02Id : ''} className="modal-disable-select" style={{
			width: '100%',
			height: '100%',
			display: 'block'
		}}>
			<canvas style={{
				position: 'absolute',
				inset: '0px',
				width: '100%',
				height: '100%',
				boxSizing: 'content-box'
			}} ref={canvas} height="161" width="1041">
			</canvas>
		</div>
	);
};

class Graph {
	private _width = 0;
	private _height = 0;
	private _context: any = null;
	private _gridTileWidth = 10;
	private _currentXvalue = 0;
	private _lastYvalue = 0;
	constructor(private _canvas: any, private _lineColor: string, private _showGrid: boolean, private _centerHeight: boolean) { }
	public init(): void {
		this._canvas.setAttribute('width', this._canvas.offsetWidth);
		this._canvas.setAttribute('height', this._canvas.offsetHeight);
		this._canvas.style.backgroundColor = 'rgb(0,0,0)';
		this._width = this._canvas.offsetWidth;
		this._height = this._canvas.offsetHeight;
		this._context = this._canvas.getContext('2d');
	}

	public drawGrid() {
		this._context.lineWidth = 1;
		var i;
		var verticalGridTiles = this._width / this._gridTileWidth;

		if (this._showGrid) {
			for (i = 0; i < verticalGridTiles; i++) {
				this._context.beginPath();
				if (i / 5 == Math.round(i / 5)) {
					this._context.strokeStyle = 'grey';
					this._context.lineWidth = 2;
				} else {
					this._context.strokeStyle = 'rgb(80,80,80)';
					this._context.lineWidth = 1;
				}
				this._context.moveTo(i * this._gridTileWidth, 0);
				this._context.lineTo(i * this._gridTileWidth, this._height);
				this._context.stroke();
			}
		}
		i = 0;
		for (i = 0; i < verticalGridTiles; i++) {
			this._context.beginPath();
			if (this._showGrid) {
				if (i / 5 == Math.round(i / 5)) {
					this._context.strokeStyle = 'grey';
					this._context.lineWidth = 2;
				} else {
					this._context.strokeStyle = 'rgb(80,80,80)';
					this._context.lineWidth = 1;
				}

			}

			this._context.moveTo(0, i * this._gridTileWidth); //trace vertical line

			if (this._showGrid) {
				this._context.lineTo(this._width, i * this._gridTileWidth);
			}

			this._context.stroke(); //render either grid & vertical line or just vertical line
		}
	}

	public drawValue(value: number) {
		this._context.clearRect(this._currentXvalue, 0, 20, this._height);
		if (this._currentXvalue > this._width) {
			this._currentXvalue = 0;
		}
		this._context.lineWidth = 3;
		this._context.strokeStyle = this._lineColor;
		if (this._centerHeight) {
			var center = this._height / 1.4;
		}
		else var center = this._height / 1.7;
		this._context.moveTo(this._currentXvalue, center - this._lastYvalue);
		this._currentXvalue++;
		this._context.lineTo(this._currentXvalue, center - value);
		this._context.stroke();
		this._lastYvalue = value;
		this.drawGrid();

	}
}

export interface SingleGraphUIMainConfig extends BaseConfig {
	graphs: SingleGraphUIConfig[];
	initData: SingleGraphInitData;
	onGetGraph: () => SingleGraphUIConfig;
	onUpdateVisibility?: () => boolean;
}

export interface SingleGraphInitData {
	showGrid: boolean;
	smoothlyZeroOut?: boolean;
	defaultCoordinates: number[];
	defaultCurveResetTimer: number;
	timeInterval: number;
	lineColor: string;
	centerHeight: boolean;
	isHeartRate?: boolean;
}

export interface SingleGraphUIConfig {
	coordinates?: number[];
	curveResetTimer?: number;
	smoothStep?: number;
}
export default SingleGraphUI;